import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { ComponentPropsWithRef } from '../../types/utils';
import { getInputClassName, InputClassProps } from '../input-class-name.util';

type SelectOwnProps = InputClassProps;

export type SelectProps = Omit<ComponentPropsWithRef<'select'>, 'multiple'> &
  SelectOwnProps;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select(
    {
      className,
      variant,
      disabled,
      hasError = false,
      fullWidth = true,
      height = 'md',
      children,
      ...rest
    },
    ref
  ) {
    return (
      <select
        ref={ref}
        disabled={disabled}
        aria-invalid={hasError || undefined}
        className={classNames(
          'bg-select bg-no-repeat',
          getInputClassName({ variant, disabled, hasError, fullWidth, height }),
          {
            'bg-right-4 pr-8': height === 'md',
            'bg-right-2 pr-8': height === 'sm',
          },
          className
        )}
        {...rest}
      >
        {children}
      </select>
    );
  }
);
